import { useCallback, useState } from 'react';
import { FieldArrayWithId } from 'react-hook-form';
import { useToggle } from '../../../../hooks/use-toggle';

export const useContactsSectionManagement = (fields: FieldArrayWithId[]) => {
  const [isManageModeEnabled, toggleManageMode] = useToggle(false);
  const [selectedContactsIds, setSelectedContactsIds] = useState<Set<string>>(new Set());

  const handleContactSelectionToggle = useCallback((id: string) => {
    setSelectedContactsIds((prevState) => {
      const newSet = new Set(prevState);
      const isAlreadySelected = newSet.has(id);

      if (isAlreadySelected) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }

      return newSet;
    });
  }, []);

  const handleRemoveFromSelectedContacts = useCallback((ids: string[]) => {
    setSelectedContactsIds((prevState) => {
      const newSet = new Set(prevState);

      ids.forEach((id) => {
        newSet.delete(id);
      });

      return newSet;
    });
  }, []);

  const handleSelectAllContacts = useCallback(() => {
    setSelectedContactsIds(new Set(fields.map((field) => field.id)));
  }, [fields]);

  const handleDeselectAllContacts = useCallback(() => {
    setSelectedContactsIds(new Set());
  }, []);

  const checkIsContactSelected = useCallback(
    (id: string) => {
      return selectedContactsIds.has(id);
    },
    [selectedContactsIds],
  );

  return {
    isManageModeEnabled,
    toggleManageMode,
    selectedContactsIds,
    handleContactSelectionToggle,
    handleSelectAllContacts,
    handleRemoveFromSelectedContacts,
    handleDeselectAllContacts,
    checkIsContactSelected,
  };
};
